import { AnyAction } from 'redux';
import processRequest from 'src/services/processRequest';
import { setRequestStatus } from 'data-layer-cr/dist/network';
import { ServerResponse } from 'data-layer-cr/dist/models';
import { AppThunk, AsyncAppThunk, AsyncDispatch } from '../../ThunkTypes';
import { updateACHPaymentData, updateIsValidAccountNumber } from '../slice';

import { ValidationAccountNumber } from '../../../models/responseTypes/ValidationAccountNumber';
import ACHData from '../../../models/helperTypes/ACHData';
import { VALIDATE_ACCOUNT_NUMBER } from '../slice/requestIdentifiers';

export const setACHData =
  (achData: ACHData): AppThunk =>
  (dispatch): void => {
    dispatch(updateACHPaymentData(achData));
  };

export const validateAccountNumber =
  (
    entityCode: string,
    accountNumber: string,
    accountType: string,
  ): AsyncAppThunk =>
  async (dispatch: AsyncDispatch): Promise<AnyAction> => {
    dispatch(setRequestStatus(VALIDATE_ACCOUNT_NUMBER, 'requesting'));
    try {
      const response = await processRequest<
        ServerResponse<ValidationAccountNumber>
      >({
        method: 'GET',
        url: `banks/validateAccountNumber/${entityCode}/${accountType}/${accountNumber}`,
      });
      dispatch(updateIsValidAccountNumber(response.data.isValid));
      return dispatch(setRequestStatus(VALIDATE_ACCOUNT_NUMBER, 'success'));
    } catch (e) {
      return dispatch(setRequestStatus(VALIDATE_ACCOUNT_NUMBER, 'failure'));
    }
  };
